import { Component, OnInit, Output, EventEmitter, HostListener, ViewChild, ElementRef, Input } from '@angular/core';
import { CookieService } from "angular2-cookie/core";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GlobalsService } from '../common/services/globals.service';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { AdverseDetailObj } from '../common/paymentpayload';
import { SharedService } from '../common/services/shared.service';

@Component({
  selector: 'app-adverse-notification',
  templateUrl: './adverse-notification.component.html',
  styleUrls: ['./adverse-notification.component.css']
})
export class AdverseNotoficationComponent implements OnInit {
  //@ViewChild('dataContainer') dataContainer: ElementRef;

  @Input() adverseNotificationDetails: {
    adverseNote: string;
    firstName: string;
    lastName: string;
    acctName: string;
    businessName: string;
    merchantId: string;
    referenceId: string;
    productCode: string;
    memberEmailAddress: string;
    addressLine1: string;
    addressLine2: string;
    city: string;
    state: string;
    postalCode: string;
    UserType: string;
    partner: string;
    failureCount: number;
    language: string;
    applicationId: string;
  };

  @Output() adverseNotificationStatus = new EventEmitter<string>();
  @Output() reSubmitPaymentStatus = new EventEmitter<string>();

  fieldValidity: Map<string, string> = new Map<string, string>();
  numericReg = /^\d+$/;
  adverseForm: FormGroup;
  AdverseDetailObj: AdverseDetailObj = {};
  contactEmailAddress: string;
  addrLine1: string;
  addrLine2: string;
  city: string;
  state: string;
  zip: string;
  adverseActionYesNo: boolean = false;
  billingEmailAddrDiffers: boolean = false;
  emailPaperMailYesNo: boolean;
  billingAddrDiffers: boolean;
  //memberEmailAddress = 'roopkumar.thumati@thryvedigital.com';
  //memberAddress = 'test, test, 12345';
  adverseType: string;
  //adverseActionType: string = 'AGENT';
  adverseEmailYesNo: string;
  AdverseActionSameEmailYesNo: string;
  AdverseActionPaperMailSameAddressYesNo: string;
  isEmailChecked: boolean;
  isPaperMailChecked: boolean;
  success: boolean = false;
  emailSuccess: boolean = false;
  paperMailSuccess: boolean = false;
  acknowledged: boolean = false;
  adverseActionEmailYesNo: string;
  termsAndConditionsRead: boolean = false;




  constructor(
    private _global: GlobalsService,
    private route: ActivatedRoute,
    private http: HttpClient,
    private router: Router,
    private cookieService: CookieService,
    private formBuilder: FormBuilder,
    private sharedService: SharedService,
  ) { }



  ngOnInit() {
    //document.getElementById("radioButtonID")
    //const input = document.getElementById("papermailRadio") as HTMLInputElement;
    //input.checked = false;
    //this.dataContainer.nativeElement.innerHTML = this.adverseNotificationDetails.adverseNote;
    this.fieldValidity.set('contactEmailAddress', '');
    this.fieldValidity.set('contactEmailConfirmAddress', '');
    this.fieldValidity.set('addrLine1', '');
    this.fieldValidity.set('addrLine2', '');
    this.fieldValidity.set('city', '');
    this.fieldValidity.set('state', '');
    this.fieldValidity.set('zip', '');

    this.adverseForm = this.formBuilder.group({
      addrLine1: [''],
      addrLine2: [''],
      city: [''],
      state: [''],
      zip: [''],
      contactEmailAddress: [''],
      contactEmailConfirmAddress: ['']
    }, {
      validator: this.MustMatch('contactEmailAddress', 'contactEmailConfirmAddress')
    });
  }

  // @HostListener('scroll', ['$event'])
  // onScroll(event: any) {
  //   if ((Math.abs(event.target.scrollTop - (event.target.scrollHeight - event.target.offsetHeight))) < (event.target.scrollHeight * 0.1)) {
  //     this.termsAndConditionsRead = true;
  //   }
  // }

  get f() { return this.adverseForm.controls; }

  get memberAddress() {
    if(this.adverseNotificationDetails.addressLine2 === undefined || this.adverseNotificationDetails.addressLine2 === null || this.adverseNotificationDetails.addressLine2 === ''){
      return this.adverseNotificationDetails.addressLine1 + ' - ' +
          this.adverseNotificationDetails.city + ', ' + this.adverseNotificationDetails.state + ', ' + this.adverseNotificationDetails.postalCode;
    }
    else {
      return this.adverseNotificationDetails.addressLine1 + ', ' + this.adverseNotificationDetails.addressLine2 + ' - ' +
          this.adverseNotificationDetails.city + ', ' + this.adverseNotificationDetails.state + ', ' + this.adverseNotificationDetails.postalCode;
    }
  }

  get memberEmailAddress() {
    return this.adverseNotificationDetails.memberEmailAddress;
  }

  get UserType() {
    return this.adverseNotificationDetails.UserType.toLowerCase();;
  }

  get partner() {
    return this.adverseNotificationDetails.partner;
  }

  get failureCount() {
    return this.adverseNotificationDetails.failureCount;
  }
  MustMatch(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
      const control = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[matchingControlName];

      if (matchingControl.errors && !matchingControl.errors.mustMatch) {
        // return if another validator has already found an error on the matchingControl
        return;
      }

      // set error on matchingControl if validation fails
      if (control.value !== matchingControl.value) {
        matchingControl.setErrors({ mustMatch: true });
      } else {
        matchingControl.setErrors(null);
      }
    };
  }

  onKey(event) {
    //Shared fields
    if (event.target.name == 'contactEmailAddress') {
      if (event.target.value == "") {
        this.fieldValidity.set('contactEmailAddress', 'required');
      } else if (!event.target.value.match('[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,3}$')) {
        this.fieldValidity.set('contactEmailAddress', 'invalid');
      } else {
        this.fieldValidity.set('contactEmailAddress', '');
      }
    } else if (event.target.name == 'contactEmailConfirmAddress') {
      if (event.target.value == "") {
        this.fieldValidity.set('contactEmailConfirmAddress', 'required');
      } else if (event.target.value != this.contactEmailAddress.valueOf()) {
        this.fieldValidity.set('contactEmailConfirmAddress', 'invalid');
      } else {
        this.fieldValidity.set('contactEmailConfirmAddress', '');
      }
    } else if (event.target.name == 'addrLine1') {
      if (event.target.value == "") {
        this.fieldValidity.set('addrLine1', 'required');
      } else if (event.target.value.length < 5) {
        this.fieldValidity.set('addrLine1', 'invalid');
      } else {
        this.fieldValidity.set('addrLine1', '');
      }
    } else if (event.target.name == 'city') {
      if (event.target.value == "") {
        this.fieldValidity.set('city', 'required');
      } else if (event.target.value.length < 2 || (this.numericReg.test(event.target.value))) {
        this.fieldValidity.set('city', 'invalid');
      } else {
        this.fieldValidity.set('city', '');
      }
    } else if (event.target.name == 'zip') {
      if (event.target.value == "") {
        this.fieldValidity.set('zip', 'required');
      } else if (event.target.value.length != 5 || !(this.numericReg.test(event.target.value))) {
        this.fieldValidity.set('zip', 'invalid');
      } else {
        this.fieldValidity.set('zip', '');
      }
    }
  }

  toggleAdverseActionEmailYesNo(adverseEmailYesNo) {
    //this.adverseEmailYesNo = adverseEmailYesNo;
    this.adverseActionEmailYesNo = adverseEmailYesNo;
    this.adverseType = 'email';
    if (this.memberEmailAddress != '' && this.memberEmailAddress != null) {
      this.adverseActionEmailYesNo = 'emailyes';
    } else {
      this.AdverseActionSameEmailYesNo = 'sameemailno';
    }
    //this.AdverseActionSameEmailYesNo = 'sameemailno';
    if (adverseEmailYesNo === 'emailno') {
      this.adverseType = '';
      this.adverseActionEmailYesNo = '';
      this.AdverseActionSameEmailYesNo = '';
    }
  }

  toggleAdverseActionSameEmailYesNo(AdverseActionSameEmailYesNo) {
    this.AdverseActionSameEmailYesNo = AdverseActionSameEmailYesNo;
    if (AdverseActionSameEmailYesNo === 'sameemailyes') {
      this.isEmailChecked = true;
    } else {
      this.isEmailChecked = false;
    }
  }

  toggleAdverseActionSelect(adversetype) {
    //this.emailPaperMailYesNo = !this.emailPaperMailYesNo;
    this.adverseType = adversetype;
    this.AdverseActionSameEmailYesNo = '';
    this.AdverseActionPaperMailSameAddressYesNo = '';
    if (adversetype === 'email' && (this.memberEmailAddress === '' || this.memberEmailAddress === null)) {
      this.AdverseActionSameEmailYesNo = 'sameemailno';
    } else if (adversetype === 'papermail' && (this.memberAddress === '' || this.memberAddress === null)) {
      this.AdverseActionPaperMailSameAddressYesNo = 'papermailsameaddressno';
    }
  }

  toggleBillingAddr(AdverseActionPaperMailSameAddressYesNo) {
    this.AdverseActionPaperMailSameAddressYesNo = AdverseActionPaperMailSameAddressYesNo;
    if (AdverseActionPaperMailSameAddressYesNo === 'papermailsameaddressyes') {
      this.isPaperMailChecked = true;
    } else {
      this.isPaperMailChecked = false;
    }
  }

  checkAcknowledge(event) {
    this.acknowledged = event;
    if (this.acknowledged) {
      this.adverseAcknowledgement();
    }
  }

  adverseAcknowledgement() {
    let applicationName;
    if(location.href.includes("sbe")) {
      applicationName = "SBE"
    } else if(location.href.includes("ffm")) {
      applicationName = "FFM"
    } else {
      applicationName = "GWC"
    }
    var adverseAcknowledgementReferenceId = {
      'referenceId': this.adverseNotificationDetails.referenceId,
      'applicationName': applicationName
    }

    this.http.post<any>(this.sharedService.getURI('sendAdverseAcknowledgement'), JSON.stringify(adverseAcknowledgementReferenceId)).subscribe(data => {
    });
  }

  submitAdverse(adverseType) {
    this.AdverseDetailObj.firstName = this.adverseNotificationDetails.firstName;
    this.AdverseDetailObj.lastName = this.adverseNotificationDetails.lastName;
    if (this.AdverseActionSameEmailYesNo === 'sameemailyes') {
      this.AdverseDetailObj.email = this.adverseNotificationDetails.memberEmailAddress;
    } else {
      this.AdverseDetailObj.email = this.contactEmailAddress;
    }
    if (this.AdverseActionPaperMailSameAddressYesNo === 'papermailsameaddressyes') {
      this.AdverseDetailObj.addressLine1 = this.adverseNotificationDetails.addressLine1;
      this.AdverseDetailObj.addressLine2 = this.adverseNotificationDetails.addressLine2;
      this.AdverseDetailObj.city = this.adverseNotificationDetails.city;
      this.AdverseDetailObj.state = this.adverseNotificationDetails.state;
      this.AdverseDetailObj.postalCode = this.adverseNotificationDetails.postalCode;
    } else {
      this.AdverseDetailObj.addressLine1 = this.addrLine1;
      this.AdverseDetailObj.addressLine2 = this.addrLine2;
      this.AdverseDetailObj.city = this.city;
      this.AdverseDetailObj.state = this.state;
      this.AdverseDetailObj.postalCode = this.zip;
    }
    this.AdverseDetailObj.channel = adverseType;
    this.AdverseDetailObj.letterType = 'Payor';
    this.AdverseDetailObj.language = this.adverseNotificationDetails.language;
    this.AdverseDetailObj.applicationId = this.adverseNotificationDetails.applicationId;
    this.AdverseDetailObj.referenceId = this.adverseNotificationDetails.referenceId;
    this.AdverseDetailObj.merchantId = this.adverseNotificationDetails.merchantId;
    this.AdverseDetailObj.productCode = this.adverseNotificationDetails.productCode;
    this.AdverseDetailObj.screen = 'EPAY';
    this.AdverseDetailObj.acctName = this.adverseNotificationDetails.acctName;
    if (adverseType === 'Mail') {
      if (this.UserType === 'agent') {
        this.AdverseDetailObj.userId = GlobalsService.saml.AgentID;
      }
      if (this.adverseNotificationDetails.firstName === '') {
        this.AdverseDetailObj.firstName = GlobalsService.saml.FirstName;
      }
      if (this.adverseNotificationDetails.lastName === '') {
        this.AdverseDetailObj.lastName = GlobalsService.saml.LastName;
      }
      this.AdverseDetailObj.companyName = this.AdverseDetailObj.firstName + ' ' + this.AdverseDetailObj.lastName;
    }
    this.http.post<any>(this.sharedService.getURI('adversenotification'), JSON.stringify(this.AdverseDetailObj)).subscribe(data => {
      if (data.responseMessage.result === true) {
        window.scroll(0, 0);
        this.success = true;
        if (this.AdverseDetailObj.channel === 'Email') {
          this.emailSuccess = true;
        } else {
          this.paperMailSuccess = true;
        }
      }
      this.adverseDataEventEmitter(data.responseMessage.result);
    },
      (error => {

      }));
  }

  adverseDataEventEmitter(adverseStatus) {
    this.adverseNotificationStatus.emit(adverseStatus);
  }

  reSubmitPayment(status) {
    this.reSubmitPaymentStatus.emit(status);
  }

  printAdverse(divName) {
    // var contents = document.getElementById("print-section").innerHTML;
    // 				var frame1 = document.createElement('iframe');
    // 				frame1.name = "frame3";
    // 				frame1.style.position = "absolute";
    // 				frame1.style.top = "-1000000px";
    // 				document.body.appendChild(frame1);
    // 				var frameDoc = frame1.contentWindow ? frame1.contentWindow : frame1.contentDocument.document ? frame1.contentDocument.document : frame1.contentDocument;
    // 				frameDoc.document.open();
    // 				frameDoc.document.write(require('./printPaymentReceipt.html'));
    // 				frameDoc.document.write('<body>');
    // 				frameDoc.document.write(contents);
    // 				frameDoc.document.write('</body></html>');
    // 				frameDoc.document.close();
    // 				setTimeout(function () {
    // 					window.frames["frame3"].focus();
    // 					window.frames["frame3"].print();
    // 					document.body.removeChild(frame1);
    // 				}, 500);
    // 				return false;

    // let mywindow = window.open('', 'PRINT', 'height=650,width=900,top=100,left=150');

    // mywindow.document.write(`<html><head><title>Adverse</title>`);
    // mywindow.document.write('</head><body >');
    // mywindow.document.write(document.getElementById('print-section').innerHTML);
    // mywindow.document.write('</body></html>');

    // mywindow.document.close(); // necessary for IE >= 10
    // mywindow.focus(); // necessary for IE >= 10*/

    // mywindow.print();
    // mywindow.close();

    // return true;

    // var printContents = document.getElementById(divName).innerHTML;
    //  var originalContents = document.body.innerHTML;

    //  document.body.innerHTML = printContents;

    //  window.print();

    //  document.body.innerHTML = originalContents;

    //window.close();
    var gAutoPrint = true;
    if (document.getElementById != null) {
      var html = '<HTML>\n<HEAD><title>FCRA Adverse Action Notice</title>\n';
      if (document.getElementsByTagName != null) {
        var headTags = document.getElementsByTagName("head");
        if (headTags.length > 0) html += headTags[0].innerHTML;
      }

      html += '\n</HE' + 'AD>\n<BODY>\n';
      var printReadyElem = document.getElementById(divName);

      if (printReadyElem != null) html += printReadyElem.innerHTML;
      else {
        alert("Error, no contents.");
        return;
      }

      html += '\n</BO' + 'DY>\n</HT' + 'ML>';
      var printWin = window.open('', 'PRINT', 'height=650,width=900,top=100,left=150');

      printWin.document.open();
      printWin.document.write(html);
      printWin.document.close();
      setTimeout(function () {
        printWin.print();
      }, 500);
      //printWin.close();
      //if (gAutoPrint) printWin.print();
      } 
      else alert("Browser not supported.");

    }




  }
